<template>
  <header class="app-header">
    <!-- Left -->
    <div class="app-header__left">
      <div class="navbar-brand">
        <router-link :to="{ name: 'Campaigns' }">
          <img
            class="logo-white"
            :src="`sh_static/header/optimizer-${$platform}-logo.svg`"
            alt="Logo"
          />
          <img
            class="logo-dark"
            src="sh_static/header/optimizer-logo-dark-bg.svg"
            alt="Logo"
          />
        </router-link>
      </div>
      <!-- Navbar Toggler -->
      <button class="navbar-toggler" type="button" @click="handleMinimize">
        <div class="bar1" />
        <div class="bar2" />
        <div class="bar3" />
      </button>

      <GlobalSearch v-if="['native', 'mobile'].includes($platform)" />
    </div>

    <!-- Right -->
    <b-navbar-nav class="app-header__right flex-row">
      <template v-if="$platform === 'native'">
        <span class="app-header__right__link" id="changelogWidgetId">What's New</span>
        <span @click="openHelloNext" class="app-header__right__link feature-request-link">
          <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.57341 1.39058C8.02244 0.00861168 9.97756 0.00860953 10.4266 1.39058L11.3574 4.25532C11.5582 4.87336 12.1341 5.2918 12.784 5.2918H15.7962C17.2492 5.2918 17.8534 7.15122 16.6778 8.00532L14.2409 9.77583C13.7152 10.1578 13.4952 10.8348 13.696 11.4529L14.6268 14.3176C15.0759 15.6996 13.4941 16.8488 12.3186 15.9947L9.88168 14.2242C9.35595 13.8422 8.64405 13.8422 8.11832 14.2242L5.68143 15.9947C4.50586 16.8488 2.92413 15.6996 3.37316 14.3176L4.30397 11.4529C4.50479 10.8348 4.2848 10.1578 3.75907 9.77583L1.32217 8.00532C0.1466 7.15122 0.750763 5.2918 2.20385 5.2918H5.21602C5.86586 5.2918 6.44179 4.87336 6.6426 4.25532L7.57341 1.39058Z" fill="#A872F4" fill-opacity="0.4"></path></svg>
          Roadmap & Feature Requests
        </span>
      </template>

      <b-nav-item-dropdown
        no-caret
        right
        class="app-header__right__dropdown"
        menu-class="optimizer-nav-dropdown-menu"
      >
        <template slot="button-content">
          <span class="">{{ $session.getUser().username }}</span>
          <img src="sh_static/header/avatar.png" class="img-avatar mr-1" />
        </template>
        <b-dropdown-item @click="$router.push({ name: 'Profile' })">
          Profile
        </b-dropdown-item>
        <b-dropdown-item @click="$router.push({ name: 'Settings' })">
          Settings
        </b-dropdown-item>
        <b-dropdown-item @click="logOut"> Logout </b-dropdown-item>
      </b-nav-item-dropdown>
    </b-navbar-nav>
  </header>
</template>

<script>
import GlobalSearch from '@sh/components/Utils/Search/GlobalSearch.vue';
import EventBus from '@sh/services/eventBus';

export default {
  name: 'Header',
  components: { GlobalSearch },
  created() {
    const doToggleSidebar = () => {
      if (window.outerWidth < 777) {
        document.body.classList.add('sidebar-minimized');
      } else {
        document.body.classList.remove('sidebar-minimized');
      }
    };
    doToggleSidebar();
    window.addEventListener('resize', () => {
      doToggleSidebar();
    });
    EventBus.on('click-sidebar-menu-item', () => {
      doToggleSidebar();
    });
    // Expose user to window
    const exposeUser = () => {
      const user = this.$session.getUser();
      if (user) window.user = user;
    };
    // On Authentication hook
    this.$session.afterAuthentication(() => {
      exposeUser();
    }, 'once');
    this.$session.afterLogout(() => {
      delete window.user;
    }, 'once');
    // On page reload
    if (this.$session.isAuthenticated()) {
      exposeUser();
    }
  },
  mounted() {
    if (window.dataLayer && process.env.NODE_ENV === 'production') { window.dataLayer.push({ event: 'hellonext_button' }); }
  },
  methods: {
    handleMinimize() {
      document.body.classList.toggle('sidebar-minimized');
    },
    logOut() {
      this.$session.removeToken();
      this.$router.push({ name: 'Login' });
    },
    async openHelloNext() {
      const user = this.$session.getUser();
      const { token } = await this.$api.auth.generateHelloNextToken(user);
      window.open(
        `https://roadmap.theoptimizer.io/?sso_token=${token}`,
        '_blank',
      );
    },
  },
};
</script>

<style lang="scss">
.app-header {
  position: fixed;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 6rem;
  background: $color-white;
  width: 100%;
  z-index: 1001;
  font-family: $font-family-secondary;
  border-bottom: 0.1rem solid $color-gray;

  &__left {
    display: flex;
    align-items: center;
    padding-left: 0.5rem;
    text-align: center;
    height: 100%;
    width: 25rem;
    border-right: 0.1rem solid $color-gray;

    .navbar-brand {
      margin-left: 2.5rem;
      img {
        height: 3.5rem;

        &.logo-white {
          display: block;
        }

        &.logo-dark {
          display: none;
        }
      }
    }

    .navbar-toggler {
      margin-left: 2rem;

      .bar1,
      .bar2,
      .bar3 {
        width: 2rem;
        height: 0.2rem;
        background: $black-350;
        margin: 0.4rem 0;
      }
    }
  }

  &__right {
    padding: 1.5rem 2.5rem;
    display: flex;
    align-items: center;

    &__notifications {
      position: relative;
      margin-right: 3rem;
      cursor: pointer;

      svg {
        height: 1.9rem;
        width: 1.9rem;
        margin-top: 0.4rem;
      }

      .badge {
        position: absolute;
        font-size: 1.1rem;
        top: -0.1rem;
        left: 1.3rem;
        border-radius: 50%;
        line-height: 1.2rem;
      }
    }

    &__dropdown {
      display: flex;
      align-items: center;
      font-size: 1.4rem;
      color: $color-dark;
      font-weight: 500;
      text-decoration: none;

      .nav-link {
        color: $color-dark;
        display: flex;
        align-items: center;
      }

      img {
        height: 3.5rem;
        width: 3.5rem;
        border-radius: 50%;
        margin-left: 0.7rem;
      }
    }

    &__link {
      font-size: 1.4rem;
      color: $color-dark;
      font-weight: 500;
      text-decoration: none;
      margin-right: 2rem;
      cursor: pointer;

      &.feature-request-link {
        display: flex;
        align-items: center;
        padding: .5rem 1.3rem;
        border-radius: .3rem;
        background: #61daff21;
        color: #1d6a81;

        &:hover {
          color: #1d6a81;
        }

        svg {
          margin-right: 1rem;

          path {
            fill: #1d6a81;
          }
        }

        @media screen and (max-width: 1250px) {
          display: none;
        }
      }

      &:hover {
        text-decoration: none;
        color: $color-dark;
      }

      &-item {
        background: rgba(#EAE9FE, 0.5);
        padding: 8px 10px;
        margin-right: 10px;
        border-radius: 5px;
        cursor: pointer;
      }

      @media screen and (max-width: 1250px) {
        display: none;
      }
    }
  }

  #hn-changelog-indicator {
    margin-right: 5px;
  }
}

.dark,
.dark-blue {
  .logo-white {
    display: none !important;
  }

  .logo-dark {
    display: block !important;
  }
}

.new-items {
  width: 250px;
  height: 250px;
}

.item {
  margin-right: 20px;
  @media screen and (max-width: 1250px) {
    display: none;
  }
}
</style>
